
import React from 'react';
import { CardContent } from '@/components/ui/card';
import CameraButton from '../CameraButton';
import ScannerDivider from '../ScannerDivider';
import CodeEntryForm from '../CodeEntryForm';

interface ScannerCardContentProps {
  openCamera: () => void;
  onCodeSubmit: (code: string) => void;
  isMobile: boolean;
}

const ScannerCardContent = ({ 
  openCamera, 
  onCodeSubmit, 
  isMobile 
}: ScannerCardContentProps) => {
  return (
    <CardContent className="space-y-4 pt-5">
      <CameraButton 
        onClick={openCamera} 
        isMobile={isMobile} 
        data-qr-scanner-button="true"
      />
      
      <ScannerDivider />
      
      <CodeEntryForm 
        onCodeSubmit={onCodeSubmit} 
        isMobile={isMobile} 
      />
    </CardContent>
  );
};

export default ScannerCardContent;
